import ContactFormSvgWrapper from "@/components/utils/contact-form/ContactFormSvgWrapper";

export default {
  props: ['isActive', 'value'],
  components: {
    ContactFormSvgWrapper
  },
  computed: {
    input: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
    active: {
      get: function () {
        return this.isActive === this.name
      },
      set: function (newValue) {
        this.$emit('active', newValue)
      }
    }
  },
}
